import { render, staticRenderFns } from "./finalizadas.vue?vue&type=template&id=3b80da51"
import script from "./finalizadas.vue?vue&type=script&lang=js"
export * from "./finalizadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports